import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostFile } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";


export const FileValidationAction = createAsyncThunk(
    "fileValidation", async (arg, { rejectWithValue }) => {
        try {
            const response = await doPostFile(urls?.fileValidation, arg);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    }
)

export const FileValidationActionSlice = createSlice({
    name: "fileValidation",
    initialState: {
        isLoading: false,
        success: false,
        error: null,
        data: false,
    },
    reducers: {
        fileValidationReset: () => {
            return {
                isLoading: false,
                success: false,
                error: null,
                data: false,
            }
        }
    },
    extraReducers: {
        [FileValidationAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.success = true;
            state.error = false;
            state.data = payload;

        },
        [FileValidationAction.pending]: (state) => {
            state.isLoading = true;
            state.success = false;
            state.error = false;
        },
        [FileValidationAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.success = false;
            state.error = payload;
        }
    }
})

export const { fileValidationReset } = FileValidationActionSlice.actions;